module.exports = __webpack_public_path__ + "static/img/logo95.e83071a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo95.png
// module id = oIdc
// module chunks = 1